export function getReadingTime(text: string, charactersPerMinute = 200): string {
  return Math.ceil(text.split(' ').length / charactersPerMinute) + ' min read';
}
